import * as React from "react";
import {Icon} from "../../../../../hiberUiKit/src/atoms/Icon/Icon";
import {Option} from "ts-option";
import IconWrapper from "../../../../../hiberUiKit/src/atoms/Icon/IconWrapper";
import ButtonPrimary from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import "./reconciliationModal.scss"
import * as classNames from "classnames";

interface IProps {
	referenceNumber: Option<string>;
	due: number
	onMatchRemainingAmount: () => void;
	onReferenceNumberClick: () => void;
	onUndoReconciliationClick: () => void;
	readOnly?: boolean
}

export const ReconciliationSuccess: React.SFC<IProps> = (props) => {
	const classFromProps = classNames({
		"c-reconciliation-modal_success-container": true,
		"readonly": props.readOnly
	});
	return (
		<div className={classFromProps}>
			<img className="c-reconciliation-modal_success-image" src="/assets/img/icons/icn-success-cmn.svg"/>
			<div className="c-reconciliation-modal_success-title">Reconciled</div>
			{!props.readOnly && <div className="c-reconciliation-modal_success-subtitle">
				<span>Matched with </span>
				<span className="c-reconciliation-modal_success-link" onClick={props.onReferenceNumberClick}>
							{props.referenceNumber.getOrElse("")}
				</span>
				<IconWrapper size={12} variant={"burgundy"} icon={Icon.ExternalSmall} viewBoxFromSize={true}/>
			</div>}
			{props.due > 0 && <ButtonPrimary label={"Match remaining amount"}
											 onClick={props.onMatchRemainingAmount}/>}
			{!props.readOnly &&
			<div className="c-reconciliation-modal_undo-link"
				 onClick={props.onUndoReconciliationClick}>
				Undo reconciliation
			</div>}
		</div>
	);
};
